import React from "react";
import { PartyPopper } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export const SubmissionCelebration = ({ open, onClose, lessonTitle }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-sm text-center" data-testid="submission-celebration">
      <div className="mx-auto h-16 w-16 rounded-full flex items-center justify-center animate-bounce" style={{ background: "#FFF3E0" }}>
        <PartyPopper className="h-8 w-8" style={{ color: "#B45309" }} />
      </div>
      <DialogHeader>
        <DialogTitle className="text-center font-head text-2xl">Well done — it's in!</DialogTitle>
        <DialogDescription className="text-center">
          Thank you for handing in {lessonTitle ? `"${lessonTitle}"` : "your assignment"}. Better late than never — your tutor will take a look soon. Keep going!
        </DialogDescription>
      </DialogHeader>
      <button data-testid="submission-celebration-close" onClick={onClose} className="mx-auto mt-2 rounded-full px-6 py-2 text-sm font-semibold text-white" style={{ background: "var(--sj-primary)" }}>Thanks!</button>
    </DialogContent>
  </Dialog>
);
